import { fetchRowChunk } from '../GscTools/query';

/**
 * The two requests this report makes, both inside one window.
 *
 * The shortlist is retrieved once per applied scope and then read repeatedly. The page request is
 * only ever sent for a query the user selected and asked to evaluate, so a report nobody evaluates
 * costs exactly one request — and an evaluation never covers more queries than were chosen.
 */

/** The scope fields both requests share. */
function common(scope) {
    return {
        searchType: scope.searchType,
        country: scope.country,
        device: scope.device,
        dataState: scope.dataState,
    };
}

/**
 * Block 01 — one chunk of query rows for the applied window: the shortlist the user selects from.
 * The shared retrieval's `auto` aggregation is by property for a query dimension.
 */
export function fetchShortlistChunk({ credentialsDomainId, scope, offset = 0 }) {
    return fetchRowChunk({
        credentialsDomainId,
        siteUrl: scope.siteUrl,
        period: scope.current,
        dimension: 'query',
        offset,
        ...common(scope),
    });
}

/**
 * Blocks 02 and 03 — the pages Search Console returned for one selected query.
 *
 * The query is sent back as an `equals` filter exactly as it was returned, since Search Console
 * compares verbatim and case-sensitively, and the dimension becomes the page — aggregated by page,
 * which is what `auto` resolves to for a page dimension. One chunk only: a query with more page
 * rows than that is reported as capped rather than paged through, because the shares are then of
 * the rows retrieved and the page says so.
 */
export function fetchQueryPages({ credentialsDomainId, scope, query }) {
    return fetchRowChunk({
        credentialsDomainId,
        siteUrl: scope.siteUrl,
        period: scope.current,
        dimension: 'page',
        filters: [{ dimension: 'query', operator: 'equals', expression: query }],
        ...common(scope),
    });
}
